import { render, staticRenderFns } from "./KeywordChart.vue?vue&type=template&id=35cc4395&scoped=true&"
import script from "./KeywordChart.vue?vue&type=script&lang=js&"
export * from "./KeywordChart.vue?vue&type=script&lang=js&"
import style0 from "./KeywordChart.vue?vue&type=style&index=0&id=35cc4395&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cc4395",
  null
  
)

export default component.exports